<section class='home'>

<section class='router'>
<router-outlet>
      <mat-progress-spinner color="primary" *ngIf="loading" mode="indeterminate" strokeWidth="5"></mat-progress-spinner>
</router-outlet>
</section>
<app-footer></app-footer>
</section>
